<template>
  <div
    v-if="$mq !== 'sm'"
    :class="'side-menu'"
  >
    <ul>
      <li class="side-menu__item home">
        <router-link
          class="icon position-relative"
          to="/"
        >
          <i class="enjoj-wonen" />
        </router-link>
        <div class="info position-absolute font-patrick-hand">
          Terug naar ENJOJ home
        </div>
      </li>
      <li
        v-for="(item, index) in menuItems"
        :key="index"
        class="side-menu__item"
      >
        <router-link v-if="!item.disabled"
          :class="{ disabled: item.disabled }"
          class="icon position-relative"
          :to="{ name: item.name }"
        >
          <i :class="item.icon" />
        </router-link>
        <span
          v-else
          :class="{ disabled: item.disabled }"
          class="icon position-relative"
        >
          <i :class="item.icon" />
        </span>
        <div
          :class="{ disabled: item.disabled }"
          class="info position-absolute font-patrick-hand"
        >
          <span
            v-if="item.disabled"
          >
            {{ item.title }} - binnenkort beschikbaar
          </span>
          <span v-else>Naar {{ item.title.toLowerCase() }}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { navigation } from '@/assets/js/header'

export default {
  name: 'ec-business-enjoj-menu',
  data () {
    return {
      menuItems: navigation
    }
  }
}
</script>
